import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/login/services/auth.service';
import { LoginRequest } from 'src/app/login/models/login.request';
import { UserService } from 'src/app/users/services/user.service';
import { UserPasswordRequest } from 'src/app/users/models/user-password.request';
import { User } from 'src/app/users/models/user';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Store } from '@ngrx/store';
import * as fromAuth from './../../../../store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  isUpdating = false;
  notifications: any;

  @Input() infoUser: User;

  cpFormGroup: FormGroup;
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private storeAuth: Store<fromAuth.AuthState>,
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService
  ) {
    this.translate
      .get('changePasswordModal.notifications')
      .subscribe(res => (this.notifications = res));
  }

  ngOnInit() {
    this.cpFormGroup = this.fb.group({
      currentPassword: [
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(20),
          Validators.minLength(12),
          Validators.pattern(
            /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{0,100}$/
          )
        ])
      ],
      newPassword: [
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(20),
          Validators.minLength(12),
          Validators.pattern(
            /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{0,100}$/
          )
        ])
      ],
      repeatPassword: [
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(20),
          Validators.minLength(12),
          Validators.pattern(
            /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{0,100}$/
          )
        ])
      ]
    });
  }

  onClickCancelar() {
    this.modalService.dismissAll();
  }

  cpFormGroupSubmit(cpFormGroup: FormGroup) {
    this.isUpdating = true;

    if (cpFormGroup.invalid) {
      this.isUpdating = false;
      return true;
    }

    if (cpFormGroup.value.newPassword !== cpFormGroup.value.repeatPassword) {
      this.isUpdating = false;
      this.notificationService.warning(this.notifications.passwordsDontMatch);
      return true;
    }

    if (cpFormGroup.value.currentPassword === cpFormGroup.value.newPassword) {
      this.isUpdating = false;
      this.notificationService.warning(
        this.notifications.passwordShouldNotBeTheSame
      );
      return true;
    }

    this.infoUser;
    const request = new LoginRequest(
      this.infoUser.email,
      cpFormGroup.value.currentPassword
    );
    const userPasswordRequest: UserPasswordRequest = {
      password: cpFormGroup.value.newPassword,
      confirmPassword: cpFormGroup.value.repeatPassword,
      type: 'CHANGE_PASSWORD'
    };
    this.authService.verifyCredential(request).subscribe(
      response => {
        if (response.status === 200 && response.data) {
          this.userService
            .setPassword(this.infoUser.id, userPasswordRequest)
            .subscribe(success => {
              this.notificationService.successful(
                this.notifications.passwordUpdated
              );
              setTimeout(() => {
                this.isUpdating = false;
                this.modalService.dismissAll();
                this.storeAuth.dispatch(fromAuth.logout());
                this.authService.cleanSession();
              }, 3000);
            });
        } else {
          this.notificationService.warning(this.notifications.wrongPassword);
          this.isUpdating = false;
        }
      },
      error => {
        this.isUpdating = false;
      }
    );
  }

  get errorPasswordPattern() {
    if (this.cpFormGroup.get('currentPassword').hasError('pattern')) {
      return this.cpFormGroup.get('currentPassword').hasError('pattern');
    }
    if (this.cpFormGroup.get('newPassword').hasError('pattern')) {
      return this.cpFormGroup.get('newPassword').hasError('pattern');
    }
    if (this.cpFormGroup.get('repeatPassword').hasError('pattern')) {
      return this.cpFormGroup.get('repeatPassword').hasError('pattern');
    }
  }

  get errorPasswordMinLengthA() {
    return this.cpFormGroup.get('currentPassword').hasError('minlength');
  }

  get errorPasswordMaxLengthA() {
    return this.cpFormGroup.get('currentPassword').hasError('maxlength');
  }

  get errorPasswordMinLengthB() {
    return this.cpFormGroup.get('newPassword').hasError('minlength');
  }

  get errorPasswordMaxLengthB() {
    return this.cpFormGroup.get('newPassword').hasError('maxlength');
  }

  get errorPasswordMinLengthC() {
    return this.cpFormGroup.get('repeatPassword').hasError('minlength');
  }

  get errorPasswordMaxLengthC() {
    return this.cpFormGroup.get('repeatPassword').hasError('maxlength');
  }
}
